import ac from 'argument-contracts';
import { coerce } from '@meltwater/coerce';
import { DateRangeRepository } from '../date-range-repository';
import { FiltersRepository } from '../filters-repository';
import { InputsRepository } from '../inputs-repository';

/**
 * @internal
 *
 * This is a private implementation meant only for use in the internal of the AppletHost
 *
 * DO NOT EXPOSE PUBLICLY!
 */
export class Namespace {
    constructor({
        dateRangeRepository,
        secondaryDateRangeRepository,
        filtersRepository,
        inputsRepository,
        coordinatedQueryTimeProvider,
        fallbackPropertiesArray = []
    }) {
        ac.assertFunction(coordinatedQueryTimeProvider, 'coordinatedQueryTimeProvider');
        ac.assertArrayOf(fallbackPropertiesArray, String, 'fallbackPropertiesArray');

        this.coordinatedQueryTimeProvider = coordinatedQueryTimeProvider;
        this.dateRangeRepository = coerce(dateRangeRepository, DateRangeRepository, `expected dateRangeRepository to be coercable to DateRangeRepository. Provided value: ${dateRangeRepository}`);
        this.inputsRepository = coerce(inputsRepository, InputsRepository, `expected inputsRepository to be coercable to InputsRepository. Provided value: ${inputsRepository}`);
        this.fallbackPropertiesArray = fallbackPropertiesArray;

        if (filtersRepository) {
            this.filtersRepository = coerce(filtersRepository, FiltersRepository, `expected filtersRepository to be coercable to FiltersRepository. Provided value: ${filtersRepository}`);
        }

        if (secondaryDateRangeRepository) {
            this.secondaryDateRangeRepository = coerce(secondaryDateRangeRepository, DateRangeRepository, `expected secondaryDateRangeRepository to be coercable to DateRangeRepository. Provided value: ${secondaryDateRangeRepository}`);
        }

        Object.freeze(this);
    }
}
